<template>

  <div>
    <div class="password-note">
      <div class="password-note-title">
        * Mật khẩu phải thỏa mãn các điều kiện sau:
      </div>

      <ul>
        <li>Dài tối thiểu <b>8 ký tự</b>.</li>
        <li>Có ít nhất <b>1 chữ cái viết hoa</b> (A-Z).</li>
        <li>Có ít nhất <b>1 chữ cái viết thường</b> (a-z).</li>
        <li>Có ít nhất <b>1 chữ số</b> (0-9).</li>
        <li>Có ít nhất <b>1 ký tự đặc biệt</b> (!, @, #, $, %, ...).</li>
        <li>Mật khẩu mới <b>không được trùng</b> mật khẩu hiện tại.</li>
      </ul>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'ChangePasswordDialog',
    data() {
      return {

      }
    },

    methods: {





    }
  }
</script>
<style scoped>
.password-note {
    margin-top: 16px;
    padding: 14px 16px;
    background: #fff8e6;
    border: 1px solid #ffe58f;
    border-radius: 10px;
}

.password-note-title {
    font-size: 14px;
    font-weight: 600;
    color: #d48806;
    margin-bottom: 8px;
}

.password-note ul {
    margin: 0;
    padding-left: 18px;
}

.password-note li {
    color: #595959;
    font-size: 13px;
    line-height: 24px;
}
</style>
